var Handlebars = require("/Users/Shanfan/enhancer/widget-configurator/enhancer-custom-window/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"dependent-vars ui-widget-content\">\n    <div class=\"dependent-vars-title ui-widget-header\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.depvarstitle : stack1), depth0))
    + "</div>\n    <ul class=\"dependent-vars-list\"></ul>\n    <input id=\"dependent-var\" type=\"text\">\n    <button id=\"add-dep-var\" class=\"add\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.add : stack1), depth0))
    + "</button>\n</div>\n<div class=\"supported-vars ui-widget-content\">\n    <div class=\"supported-vars-title ui-widget-header\">\n        "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.supvarstitle : stack1), depth0))
    + "\n    </div>\n    <ul class=\"supported-vars-list\"></ul>\n    <input id=\"supported-var\" placeholder=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.variableName : stack1), depth0))
    + "\" type=\"text\">\n    <select id=\"supported-var-type\">\n        <option>string</option>\n        <option>number</option>\n        <option>array</option>\n        <option>boolean</option>\n    </select>\n    <input id=\"supported-var-des\" placeholder=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.description : stack1), depth0))
    + "\" type=\"text\">\n    <button id=\"add-sup-var\" class=\"add\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.add : stack1), depth0))
    + "</button>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./src/managers/variable/index.html
 ** module id = 33
 ** module chunks = 0
 **/